/**
 * ViewChoice — the start choice card, shown once at the end of setup (#476):
 * "Keep it simple" or "Show me everything" (pre-selected). It never shows
 * again; after setup the view is changed in Account or with the switches.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import { useState } from 'react';
import './simple.css';

const OPTIONS = [
  ['simple', 'Keep it simple', 'Safe to spend, log a spend, tick what’s paid.'],
  ['full', 'Show me everything', 'The full Vault.'],
];

export default function ViewChoice({ busy = false, onContinue }) {
  const [pick, setPick] = useState('full');
  return (
    <div className="sv-scope sv-form" style={{ gap: '1rem' }}>
      <div style={{ fontSize: '1rem', color: 'var(--sv-a300)', marginTop: '.75rem' }}>Last step</div>
      <h2 className="sv-h1" style={{ margin: 0 }} id="sv-view-q">How would you like Vault to look?</h2>
      <div className="sv-note" style={{ fontSize: '1.0625rem' }}>You can change this any time in Account.</div>
      <div role="radiogroup" aria-labelledby="sv-view-q" style={{ display: 'flex', flexDirection: 'column', gap: '.75rem', marginTop: '.375rem' }}>
        {OPTIONS.map(([k, title, line]) => (
          <button key={k} type="button" role="radio" aria-checked={pick === k ? 'true' : 'false'}
                  className="sv-choice" onClick={() => setPick(k)}>
            <span className="sv-dot" />
            <span style={{ minWidth: 0 }}>
              <span className="sv-choice-title">{title}</span>
              <span className="sv-choice-line">{line}</span>
            </span>
          </button>
        ))}
      </div>
      <button type="button" className="sv-primary mid" style={{ marginTop: '.375rem' }} disabled={busy}
              onClick={() => onContinue(pick)}>Continue</button>
    </div>
  );
}
